import React from 'react';
import { Paper, Typography, Rating, Box, Grid, Avatar } from '@mui/material';
import { Carousel } from 'react-responsive-carousel';
import s from './CustomerCarousel.module.scss';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import imagen2 from "./assets/avatar2.jpg";
import imagen3 from "./assets/avatar3.jpg";
import imagen4 from "./assets/avatar4.jpg";
import imagen8 from "./assets/avatar8.jpg";
import imagen9 from "./assets/avatar9.jpg";
import imagen10 from "./assets/avatar10.jpg";
import imagen11 from "./assets/avatar11.jpg";


function CustomerCarousel() {
    const testimonials = [
        { 
            name: 'Elena', 
            avatar: imagen11, 
            message: 'Deseaba una solución de seguridad confiable para mi hogar,<br/> y Fustec lo hizo posible. <br/> La alarma es eficiente y su equipo profesional lo más.<br/>  Mi tranquilidad no tiene precio. ', 
            stars: 5 
        },
        { 
            name: 'Nicolás', 
            avatar: imagen2, 
            message: 'El servicio de Fustec superó mis expectativas. <br/> Las cámaras de seguridad funcionan a la perfección,<br/>  y su equipo técnico es altamente competente.', 
            stars: 4 
        },
        { 
            name: 'Camila', 
            avatar: imagen8, 
            message: 'Con Fustec, me siento siempre protegida. <br/> La instalación fue rápida y sencilla, <br/> y su equipo de atención al cliente es de primera.', 
            stars: 3.5 
        },
        { 
            name: 'Ana', 
            avatar: imagen9, 
            message: 'Desde que instalé el sistema de Fustec, aumento mi tranquilidad.<br/>  La profesionalidad y la tecnología que ofrecen son invaluables.<br/>  Los recomendaría sin dudarlo.', 
            stars: 5 
        },
        { 
            name: 'Diego', 
            avatar: imagen3, 
            message: 'El equipo de Fustec es excepcional. <br/> La instalación de mi sistema de seguridad fue rápida y eficiente.<br/>  Siento que mi local esta más seguro que nunca.', 
            stars: 3.5 
        },
        { 
            name: 'Lara', 
            avatar: imagen10, 
            message: 'El servicio que me brindan es la seguridad <br/>que necesito en mi hogar. Son eficientes y profesionales. <br/> ¡Estoy impresionada!"', 
            stars: 5 
        },
        { 
            name: 'Juan Cruz', 
            avatar: imagen4, 
            message: 'Hace poco instalé cámaras de seguridad con Fustec <br/> y estoy impresionado por su atención al detalle.<br/>  Su tecnología y servicio son de primera.<br/>  Recomiendo a todos sus servicios.', 
            stars: 3.5 
        },
        { 
            name: 'Lucas', 
            avatar: imagen2, 
            message: 'Contratar el servicio de Fustec fue una decisión inteligente.<br/>  Su tecnología es de última generación. <br/>Me siento tranquilo y protegido.', 
            stars: 5 
        },
        // Agregar más testimonios aquí
    ];

    const formatMessage = (message) => {
        return message.split('<br/>').map((line, index) => (
            <span key={index}>
                {line}
                {index < message.split('<br/>').length - 1 && <br />}
            </span>
        ));
    };

    return (
        <Grid container className={s.container} id='CustomerCarousel'>
			<Grid item xs={1} className={s.linecontainer}>
				<Box className={s.line1}></Box>
					<p>04</p>
				<Box className={s.line2}></Box>
				
			</Grid>

			<Grid item container xs={12} className={s.content}>
				<Grid item xs={10} className={s.title}>
					<h3>Nuestros Clientes</h3>
				</Grid>

				<Grid item container xs={12} >
                    <div className={s.carouselContainer}>
                    <Carousel className={s.carouselItem}
                        showArrows={true}
                        infiniteLoop={true}
                        autoPlay={true}
                        interval={5000}
                        showThumbs={false}
                        showStatus={false}
                        useKeyboardArrows={true}
                        swipeable={true}
                        emulateTouch={true}
                        
                        
                    >
                        {testimonials.map((testimonial, index) => (
                        <div key={index}  >
                            <Paper
                            elevation={3}
                            style={{
                                backgroundColor: '#222222',
                                textAlign: 'center',
                                color: 'white',
                                margin: '0 auto',
                                padding: '20px',
                            }}
                            > 
                            <Avatar alt={testimonial.name} src={testimonial.avatar} className={s.avatar}  />
                            <Typography className={s.testimonial}
                                // style={{
                                // fontSize: '1.5rem',
                                // fontWeight: 300,
                                // color: 'rgb(255, 255, 255)',
                                // margin: '1vh 0',
                                // }}
                            >
                                {formatMessage(testimonial.message)}
                            </Typography>
                            <Box component="fieldset" borderColor="transparent" style={{ marginBottom: '1vh' }}>
                                <Rating name="read-only" value={testimonial.stars} readOnly />
                                <Typography variant="h6" style={{ color: 'white' }}>
                                {testimonial.name}
                                </Typography>
                            </Box>
                            </Paper>
                        </div>
                        ))}
                    </Carousel>
                    </div>
				</Grid>
			</Grid>
		</Grid>
                
                    
                
    )
}

export default CustomerCarousel;